import moment from 'moment'

export default {
    "query": {
        "bool": {
            "must": [
                {
                    "range": {
                        "update_dates._seconds": {
                            gte: moment.utc().subtract(1, "days").valueOf() / 1000,
                        }
                    }
                }
            ],
            "must_not": {
                "exists": {
                    "field": 'hidden'
                }
            }
        },
        
    },
    "sort": [{
        "_script" : {
            "script" : `for (def item : params._source.update_dates) {
                if(item._seconds > ${moment.utc().subtract(1, "days").valueOf() / 1000}) {
                    return item._seconds
                }
            }`,
            "type" : "number",
            "order" : "asc"
        },
    }],
}